export function getOnlyNumbers(phone: any) {
  let onlyNumbers: string = '';
  let phoneInStringFormated = phone.toString();
  for (let i = 0; i < phoneInStringFormated.length; i++) {
    if (parseInt(phoneInStringFormated[i]) || phoneInStringFormated[i] == '0') {
      onlyNumbers += phoneInStringFormated[i];
    }
  }
  return onlyNumbers;
}

export function isValidNumber(num: any, size: number) {
  let numInStringFormated = num.toString();
  if (numInStringFormated.length !== size) {
    return false;
  }
  for (let i = 0; i < size; i++) {
    if (!(parseInt(numInStringFormated[i]) || numInStringFormated[i] == '0')) {
      return false;
    }
  }

  return true;
}

export function isValidPassword(password: string) {
  if (
    password.length >= 8 &&
    password.search(/[a-z]+/) !== -1 &&
    password.search(/[A-Z]+/) !== -1 &&
    password.search(/[0-9]+/) !== -1 &&
    password.search(/[!@#$%^&*_=+]+/) !== -1
  ) {
    return true;
  }
  return false;
}

export function formatPercentage(value: any): string {
  const twoDigitsWithOptionalTwoDecimalPlaces = /^(?<wholeNumber>\d{1,2})(?<decimalPoint>\.\d{0,2})?/;

  const match = value.match(twoDigitsWithOptionalTwoDecimalPlaces);

  return match ? match[0] : '';
}
